import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class BannerImage extends Component {
  @service roles;
}
